import gql from 'graphql-tag';

import { getLanguageWithoutFormality, type Language } from 'src/data/generation';
import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type {
  BackendMutationTestCustomToneOfVoiceArgs,
  BackendTovTesterVariation,
} from 'src/types/backend';

const MUTATION = gql`
  mutation TestCustomToneOfVoice(
    $customerId: ID!
    $text: String!
    $html: String
    $generationTool: GenerationToolEnum!
    $tovInput: TovInput!
    $language: String
    $structureInstructionsData: JSON
  ) {
    testCustomToneOfVoice(
      customerId: $customerId
      text: $text
      html: $html
      generationTool: $generationTool
      tovInput: $tovInput
      language: $language
      structureInstructionsData: $structureInstructionsData
    ) {
      originalCopyText
      modifiedCopyText
      modifiedCopyHtml
      tovParams {
        draftTov {
          traits {
            trait
            butNot
          }
          personality
          description
        }
      }
    }
  }
`;

type Variables = Override<
  BackendMutationTestCustomToneOfVoiceArgs,
  {
    language?: Language;
    structureInstructionsData?: Record<string, unknown>;
  }
>;
type Result = BackendTovTesterVariation;

export const testCustomToneOfVoice = async (
  {
    customerId,
    text,
    html,
    generationTool,
    tovInput,
    language,
    structureInstructionsData,
  }: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      // "text" is required, so when only "html" is provided send an empty string
      text: html && !text ? '' : text,
      html,
      generationTool,
      tovInput,
      language: language ? getLanguageWithoutFormality(language) : undefined,
      structureInstructionsData: stringifyIfPresent(structureInstructionsData),
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
